// extracted by mini-css-extract-plugin
export default {"popper":"CopyButton_popper__V-jtN","popperContent":"CopyButton_popperContent__efTuj"};